import { graphql } from 'client/gql';
import { BpPage } from 'components/BpPage/BpPage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'urql';
import { MyAbsencesSubpage } from './subpages/MyAbsencesSubpage';

export const MyAbsencesPage = () => {
  const { t } = useTranslation();

  const permissions = usePermissionChecker();

  return (
    <BpPage isForbidden={!permissions?.canViewOwnAbsences()} title={t('absences.myAbsences')}>
      <MyAbsencesSubpage />
    </BpPage>
  );
};
